import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export default function ExternalProfileRow({
  externalSystemName,
  isSelected,
  onClick,
  profileRow,
  shouldDisplaySource,
}) {
  const leftColumnText = shouldDisplaySource ? externalSystemName || 'External' : '';
  const selectorClassNames = classnames('externalCustomerLookupSearchResults-table-selector', {
    'externalCustomerLookupSearchResults-table-selector-selected': isSelected,
  });
  return (
    <tr className="externalCustomerLookupSearchResults-table-externalProfileRow">
      <td className="externalCustomerLookupSearchResults-table-sourceCell" key="externalCustomerLookup-sourceCell">
        {leftColumnText}
      </td>
      <td
        className="externalCustomerLookupSearchResults-table-externalProfileRow-dataCell externalCustomerLookupSearchResults-table-selectorSpacer"
        key="externalCustomerLookup-selectorSpacer"
        onClick={onClick}
      >
        <div className="externalCustomerLookupSearchResults-table-selectorWrapper">
          <div className={selectorClassNames} />
        </div>
      </td>
      {_.map(profileRow, (value, i) => (
        <td
          className="externalCustomerLookupSearchResults-table-externalProfileRow-dataCell"
          key={`externalCustomerLookup-external-${i}`}
          onClick={onClick}
        >
          {value}
        </td>
      ))}
    </tr>
  );
}

ExternalProfileRow.propTypes = {
  externalSystemName: PropTypes.string,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  profileRow: PropTypes.array,
  shouldDisplaySource: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/external_customer_lookup/external_profile_row.jsx